import { BaseClient, IActionResponse, IActionResult } from "../";
import { LookupModuleRouteMap, Module } from "../../../assets/types/common";
import { ApiParams, IPagedResult, SearchDto } from "../../../assets/utils/lib";

export class LookupValueClient<T> extends BaseClient {

    routes: string[] = [];
    constructor(moduleType: Module) {
        super();
        this.routes = [LookupModuleRouteMap[moduleType], "configuration"];
    }

    async getLookupValueAsync(id?: string | undefined): Promise<T> {
        const actions: string[] = ["GetLookupValue"];
        const params: ApiParams[] = [
            new ApiParams("valueId", id, true)
        ];

        return await this.getAsync<T>(actions, params);
    }

    async getLookupValuesAsync(lookupTypeId?: string | undefined): Promise<T[]> {
        const actions: string[] = ["GetCategoryLookupValues"];
        const params: ApiParams[] = [
            new ApiParams("lookupTypeId", lookupTypeId, true),
        ];

        return await this.getAsync<T[]>(actions, params);
    }

    async searchLookupValuesAsync(searchDto: SearchDto): Promise<IPagedResult<T>> {
        const actions: string[] = ["SearchLookupValue"];
        return await this.postAsync<SearchDto, T, IPagedResult<T>>(actions, searchDto);
    }

    async saveLookupValueAsync(payload?: T | undefined): Promise<IActionResult<T>> {
        const actions: string[] = ["SaveLookupValue"];
        return await this.postAsync<T>(actions, payload);
    }

    async deleteLookupValueAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteLookupValue"];
        const params: ApiParams[] = [
            new ApiParams("valueId", id, true)
        ];

        return await this.deleteAsync(actions, params);
    }

}